import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getColumbusStructuredData() {
  const url = "https://restorehair.com/locations/ohio/columbus/";
  const description =
    "Find out about your hair transplant options in Columbus with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("columbus", url, description),
    locationPageCrumbs(url, "Columbus"),
  ];
}
